// extracted by mini-css-extract-plugin
export var centerText = "_56-8";
export var container = "_56-0";
export var doughnutContainer = "_56-7";
export var legend = "_56-a";
export var legendItemColorDisplay = "_56-b";
export var legendItemLabel = "_56-d";
export var legendItemValue = "_56-c";
export var lg = "_56-5";
export var maxWidth = "_56-9";
export var md = "_56-4";
export var responsive = "_56-6";
export var sm = "_56-3";
export var xs = "_56-2";
export var xxs = "_56-1";